// ponytail: copy of app-module-order-page-confirmation/default/index.js's data-fetching
// (order/company/contact/products -> previewData for the invoice PDF), swapped to render the
// approve form instead of the confirmation forms. Needed because, unlike the plain "Approve"
// page, this one emails the invoice on approve and so needs the same previewData.
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";

/* container */
import OrderContainer from "../../app-module-order-container/default";
/* container */

/* packages */
import {
  ModuleWrapperXl,
  ModuleWrapperMain,
  ModuleWrapperMd,
  ModuleWrapperLeft,
  ModuleWrapperRight,
  ModulePaperWrapper,
} from "../../lib-atomic-design-section";
import { LocalStorage } from "../../lib-atomic-functions";
import { FetchContextApi } from "../../lib-atomic-functions";
/* packages */

/* modules */
import Loader from "../loader/orders";
import OrdersDetail from "../detail/orders";
import OrdersApprove from "../form/orders";
/* modules */

/* section */
import Nav from "../section/nav";
import Title from "../section/title";
import Action from "../section/action";
/* section */

/* functions */
import { OrderingDetail } from "../../app-module-ordering-container/functions";
import { CompanyDetail } from "../../app-module-company-container/functions";
import { ContactDetail } from "../../app-module-contact-container/functions";
import {
  ProductCat1List,
  ProductCat2List,
  ProductCat3List,
  ProductCat4List,
} from "../../app-module-product-container/functions";
/* functions */

import CONFIG from "../config";

const index = observer((props) => {
  const { orderId } = props.match.params;
  const { token } = LocalStorage.getLS().login;

  /* product */
  const { orderDetailContext, orderDetailMethod } = OrderingDetail({ CONFIG });
  const { productCat1ListContext, productCat1ListMethod, productCat1ListData } =
    ProductCat1List({ CONFIG, token });
  const { productCat2ListContext, productCat2ListMethod, productCat2ListData } =
    ProductCat2List({ CONFIG, token });
  const { productCat3ListContext, productCat3ListMethod, productCat3ListData } =
    ProductCat3List({ CONFIG, token });
  const { productCat4ListContext, productCat4ListMethod, productCat4ListData } =
    ProductCat4List({ CONFIG, token });
  /* companys */
  const { companyInfoContext, companyInfoMethod, companyInfoData } =
    CompanyDetail({
      CONFIG,
      token,
      companyId: orderDetailContext.data.clientId,
    });
  /* contacts */
  const { contactInfoContext, contactInfoMethod, contactInfoData } =
    ContactDetail({
      CONFIG,
      token,
      companyId: orderDetailContext.data.clientId,
      contactId: orderDetailContext.data.contactId,
    });

  useEffect(() => {
    orderDetailMethod({ token, orderId });
    productCat1ListMethod();
    productCat2ListMethod();
    productCat3ListMethod();
    productCat4ListMethod();
  }, [orderId]);

  useEffect(() => {
    if (orderDetailContext.data) {
      companyInfoMethod();
      contactInfoMethod();
    }
  }, [orderDetailContext.data]);

  const productsAll =
    productCat1ListData &&
    productCat2ListData &&
    productCat3ListData &&
    productCat4ListData
      ? [
          ...productCat1ListData.products,
          ...productCat2ListData.products,
          ...productCat3ListData.products,
          ...productCat4ListData.products,
        ]
      : false;

  /* laoder */
  if (orderDetailContext.loading) return <Loader />;
  if (!orderDetailContext.data) return <Loader />;
  if (!contactInfoContext.data) return <Loader />;
  if (orderDetailContext.expireToken) return <Loader />; // redirect
  if (!companyInfoData || !contactInfoData || !productsAll) return <Loader />;

  /* data loader */
  const productsData = orderDetailContext.data.detail.filter(
    (product) => product.subClassId === 2 || product.subClassId === 3,
  );
  const feesData = orderDetailContext.data.detail.filter(
    (product) => product.subClassId === 1 || product.subClassId === 5,
  );
  const productsDetailsData = productsData.map((productDetail) => {
    productDetail["details"] = productsAll.filter(
      (product) => product.productId === productDetail.productId,
    )[0];
    return productDetail;
  });
  const feesDetailsData = feesData.map((productDetail) => {
    productDetail["details"] = productsAll.filter(
      (product) => product.productId === productDetail.productId,
    )[0];
    return productDetail;
  });

  /* data props */
  const order = orderDetailContext.data;
  const previewData = {
    pdfFilename: orderId + ".pdf",
    pdfPreviewData: {
      orderInfoData: order,
      companyInfoData,
      contactInfoData,
      productsDetailsData,
      feesDetailsData,
    },
    pdfPreviewSize: {
      width: 450,
      height: 700,
    },
  };

  const filterProduct = (idList, data) => {
    return {
      products: data.detail.filter((product) =>
        idList.includes(product.subClassId),
      ),
    };
  };

  const detailData = {
    props,
    previewData,
    order: orderDetailContext.data,
    company: orderDetailContext.data,
    contact: orderDetailContext.data,
    product: filterProduct([2, 3], orderDetailContext.data),
    fee: filterProduct([1, 4], orderDetailContext.data),
  };
  /* data props */

  return (
    <OrderContainer {...props}>
      <ModuleWrapperXl>
        <Nav {...props} />
        <Title {...props} />
        <Action {...detailData} />
      </ModuleWrapperXl>

      <ModuleWrapperXl>
        <ModuleWrapperMain>
          <ModuleWrapperLeft>
            <OrdersDetail {...detailData} />
          </ModuleWrapperLeft>

          <ModuleWrapperRight>
            <ModuleWrapperMd>
              <ModulePaperWrapper>
                <OrdersApprove {...detailData} />
              </ModulePaperWrapper>
            </ModuleWrapperMd>
          </ModuleWrapperRight>
        </ModuleWrapperMain>
      </ModuleWrapperXl>
    </OrderContainer>
  );
});

export default index;
